import { useI18n } from 'vue-i18n';

import en from '../locales/en.json';
import fr from '../locales/fr.json';

export function useNotificationsI18n() {
    return useI18n({ useScope: 'isolated', messages: { en, fr } });
}
